<template>
  <div class="clock-wrapper">
    <div class="hour" :style="{'transform' : 'translateY(-4px) rotate(' + hRotate + 'deg)'}"></div>
    <div class="minute" :style="{'transform' : 'translateY(-6.5px) rotate(' + mRotate + 'deg)'}"></div>
  </div>
</template>
<script>
export default {
  props: {
    hRotate: {
      default: 0
    },
    mRotate: {
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.clock-wrapper {
  width: 32px;
  height: 32px;
  display: inline-block;
  border: 2px solid #c9c9c9;
  border-radius: 50%;
  vertical-align: middle;
  position: relative;
  .seconds {
    height: 13px;
    width: 1px;
    background: #c9c9c9;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transform-origin: bottom center;
    @include transform(translateY(-6.5px));
  }
  .minute {
    height: 13px;
    width: 2px;
    background: #c9c9c9;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transform-origin: bottom center;
    @include transform(translateY(-6.5px));
  }
  .hour {
    height: 8px;
    width: 2px;
    background: #c9c9c9;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transform-origin: bottom center;
    @include transform(translateY(-4px));
  }
}
</style>
